import toast from "react-hot-toast";
import { translations } from "../../../configs/translations";
import { useStore } from "../../../store/store";
import { VinylCard } from "../vinylsCard/VinylCard";
import './VinylsMenu.css'
import { useState } from "react";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_IMAGE_DIMENSION = 1024; // Max width/height in pixels

interface VinylsMenuProps {
    stickers: {id: number, image: string}[];
    setStickers: (stickers: {id: number, image: string}[]) => void;
    sendAddStickerAction?: (shape: 'square'|'triangle'|'circle'|'star') => void;
    sendAddStencilAction?: (image: string) => void;
    stickerIdCounter: number;
    buyStickerAction?: () => void;
    price: number | null;
}

export const VinylsMenu = ({ stickers, setStickers, sendAddStickerAction, sendAddStencilAction, stickerIdCounter, buyStickerAction, price }: VinylsMenuProps) => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];
    
    const handleStencilUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            toast.error(t.no_file_selected);
            return;
        }
    
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                if (img.width > MAX_IMAGE_DIMENSION || img.height > MAX_IMAGE_DIMENSION) {
                    toast.error(t.image_too_large);
                    return;
                }
    
                // The base64 string is already in e.target.result
                const base64Image = e.target?.result as string;
                
                
                // Send the base64 string
                sendAddStencilAction?.(base64Image);
                setStickers(
                    [...stickers, {id: -1, image: 'upload_stencil'}]
                )
            };
            img.src = e.target?.result as string;
        };
    }
      
    
    return (
        <div className="vinyls-menu-wrapper">
            <div className="vinyls-menu">

                <div className="vinyls-menu-header-container">
                    <p className="vinyls-menu-header-title">{t.stickers}</p>
                </div>

                <div className="vinyls-menu-content-container">
                    <VinylCard
                        name={t.square}
                        image="square"
                        onSelect={
                            () => {
                                sendAddStickerAction?.("square")
                                setStickers(
                                    [...stickers, {id: stickerIdCounter, image: "square"}
                                ])
                            }
                        }
                        isSelected={false}
                    />
                    <VinylCard
                        name={t.triangle}
                        image="triangle"
                        onSelect={
                            () => {
                                sendAddStickerAction?.("triangle")
                                setStickers(
                                    [...stickers, {id: stickerIdCounter, image: "triangle"}
                                ])
                            }
                        }
                        isSelected={false}
                    />
                    
                    <VinylCard
                        name={t.circle}
                        image="circle"
                        onSelect={
                            () => {
                                sendAddStickerAction?.("circle")
                                setStickers(
                                    [...stickers, {id: stickerIdCounter, image: "circle"}
                                ])
                            }
                        }
                        isSelected={false}
                    />
                    <VinylCard
                        name={t.star}
                        image="star"
                        onSelect={
                            () => {
                                sendAddStickerAction?.("star")
                                setStickers(
                                    [...stickers, {id: stickerIdCounter, image: "star"}
                                ])
                            }
                        }
                        isSelected={false}
                    />
                    <input
                        type="file"
                        id="stencil-upload"
                        accept="image/png, image/jpeg, image/jpg, image/webp"
                        style={{ display: 'none' }}
                        onChange={handleStencilUpload}
                    />
                    <VinylCard
                        name={t.stencil}
                        image="upload_stencil"
                        onSelect={
                            () => {
                                document.getElementById('stencil-upload')?.click()
                            }
                        }
                        isSelected={false}
                    />
                </div>

                <div className="vinyls-menu-footer-container">
                    <div 
                        className='tuning-button tuning-buy-button' 
                        onClick={() => {
                            buyStickerAction?.()
                        }}
                    >
                        <p>{t.buy} {price}$</p>
                    </div>
                </div>

            </div>
        </div>
    )
}